import TableBoq from '@/components/boq/TableBoq.vue'
import Loader from '@/components/layout/Loader.vue'
import Modal  from '@/components/layout/Modal.vue'
import Pagination from '@/components/layout/Pagination.vue'
import StepItem2  from '@/components/layout/StepItem2.vue'
import Select2  from '@/components/layout/Select2.vue'
import ButtonTemplateDownloader from '@/components/boq/ButtonTemplateDownloader.vue'
import BreadcrumbsProject  from '@/components/projectInformation/BreadcrumbsProject.vue'
import { LinkList, ModuleActionList, ApprovalStageBoqObj, ApprovalStageBoq } from '@/helpers/utilities.js'
import 'dotenv/config'
import {mapActions, mapGetters} from 'vuex'
import {CombineBoq, SearchQuotationList,DeleteBoq, UploadOfficeTemplateToMasterList, GetQuotationList} from '@/actions/boqActions.js'

export default {
    name : 'BoqList',
    components : {
        TableBoq,
        Loader,
        Modal,
        Pagination,
        BreadcrumbsProject,
        StepItem2,
        Select2,
        ButtonTemplateDownloader
    },
    mounted : async function(){
        const self = this
        const projectId = self.$route.params.id
        self.ChangeActiveLink(LinkList.BILL_OF_QUANTITIES)
        await self.GetProjectInfo(projectId).catch()
        const getListBoq = await self.GetBoqListRun({id : projectId,page : 1, search : ""}).catch()
        if(getListBoq==401){
            self.$router.push('/unauthorized')
            return
        }
        const quotationReferenceList = await SearchQuotationList({search : '', id : projectId})
        self.quotationList = await self.EnrichQuotationReferenceStatuses(quotationReferenceList, projectId)
        await self.GetCurrencyListRun().catch()
        self.tableIsLoading = false
    },
    methods : {
        ...mapActions(['GetBoqListRun','CreateBoqRun','UpdateBoqRun','GetProjectInfo','GetCurrencyListRun','DuplicateBoqRun','ChangeActiveLink', 'DeleteBoqPermanent']),
        FormatCurrencyName(value){
            return String(value || '')
                .replace(/\s+/g, ' ')
                .trim()
                .replace(/[A-Za-z]+/g, (word)=>{
                    if(word.length <= 3 && word === word.toUpperCase()){
                        return word
                    }

                    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
                })
        },
        timerSetter(typed, callback, seachEmpty = false){
            const self = this
            if(!seachEmpty){
                if(!typed){
                return
                }
            }
            
            if(self.timer){
                clearTimeout(self.timer)
                self.timer = null
            }

            self.timer = setTimeout(callback,700)
        },
        CreateBoq(elem){
            const self = this
            const projectId = self.$route.params.id
            const btn = elem
            self.saveClicked = true
            if(!self.boqName){
                return
            }
            btn.disabled = true
            self.tableIsLoading = true
            self.CreateBoqRun({
                    data : {projectId : projectId, name : self.boqName, reference : self.boqRef},
                    pager : {id : projectId ,page : 1, search : ""}
            })
            .then((res)=>{
                self.tableIsLoading = false
                btn.disabled = false
                if(res.status!=200){
                    if(self.isDeluxeLayout && self.IsPublishedReferenceBlockedMessage(res.data)){
                        return
                    }
                    if(self.isDeluxeLayout && self.IsBoqNameAlreadyUsed(res.data)){
                        self.ShowBoqNameInUseAlert('Add BoQ')
                    }else{
                        self.$swal(self.$i18n.t('Add BoQ'), res.data, 'warning')
                    }
                }else{
                    self.$refs.closeAddModal.click()
                    self.saveClicked = false
                }
            }).catch()
        },
        IsBoqNameAlreadyUsed(message){
            const errorMessage = typeof message == 'string' ? message : message?.message || ''
            return /name.*already|already.*exist|already.*use/i.test(errorMessage)
        },
        IsPublishedReferenceBlockedMessage(message){
            const errorMessage = typeof message == 'string' ? message : message?.message || ''
            return /reference quotation is already published|bill of quantity is already published/i.test(errorMessage)
        },
        async EnrichQuotationReferenceStatuses(referenceList, projectId){
            const list = Array.isArray(referenceList) ? referenceList : []
            const hasMissingStatus = list.some((quotation)=>quotation && quotation.approvalStage == null && quotation.status == null)

            if(!hasMissingStatus){
                return list
            }

            const quotationPage = await GetQuotationList({id: projectId, search: '', page: 1, limit: 500}).catch(()=>null)
            const quotationDocs = Array.isArray(quotationPage?.docs) ? quotationPage.docs : []
            const statusById = quotationDocs.reduce((map, quotation)=>{
                map[String(quotation._id)] = quotation.approvalStage
                return map
            }, {})

            return list.map((quotation)=>{
                return {
                    ...quotation,
                    approvalStage: quotation.approvalStage ?? quotation.status ?? statusById[String(quotation._id)]
                }
            })
        },
        ShowBoqNameInUseAlert(titleKey){
            const self = this
            self.$swal({
                html: `
                    <div class="quotation-feedback-loader-alert boq-name-alert__loader" aria-hidden="true">
                        <div class="quotation-feedback-alert-icon quotation-feedback-alert-icon--error animate">
                            <span class="quotation-feedback-alert-line quotation-feedback-alert-tip2 animateTip2"></span>
                            <span class="quotation-feedback-alert-line quotation-feedback-alert-tip3 animateTip3"></span>
                            <div class="quotation-feedback-alert-placeholder"></div>
                            <div class="quotation-feedback-alert-fix"></div>
                        </div>
                    </div>
                    <h3 class="boq-name-alert__title">${self.$i18n.t(titleKey)}</h3>
                    <p class="boq-name-alert__message">${self.$i18n.t('This BoQ name is already in use. Please choose a different name.')}</p>
                `,
                showCloseButton: true,
                confirmButtonText: self.$i18n.t('OK'),
                buttonsStyling: false,
                customClass: {
                    container: 'boq-name-alert__container',
                    popup: 'boq-name-alert',
                    htmlContainer: 'boq-name-alert__content',
                    closeButton: 'boq-name-alert__close',
                    confirmButton: 'boq-name-alert__confirm'
                }
            })
        },
        GetBoq(id, name, currency, reference){
            const self = this
            const referenceId = reference?._id || ''
            self.boqUpdateId = id
            self.boqNameUpdate = name
            self.boqCurrencyIdUpdate = currency
            self.boqRefUpdate = referenceId
            self.boqOriginalUpdate = {
                name: name || '',
                reference: referenceId
            }
            
        },
        UpdateBoq(elem){
            const btn = elem
            const self = this
            const boqId = self.boqUpdateId
            const name = self.boqNameUpdate
            const projectId = self.$route.params.id
            self.updateClicked = true
            if(!name){
                return
            }

            const nextName = String(name || '').trim().toLowerCase()
            const originalName = String(self.boqOriginalUpdate.name || '').trim().toLowerCase()
            const nextReference = String(self.boqRefUpdate || '')
            const originalReference = String(self.boqOriginalUpdate.reference || '')

            if(nextName === originalName && nextReference === originalReference){
                self.$refs.closeUpdateModal.click()
                self.updateClicked = false
                return
            }

            btn.disabled = true

            self.UpdateBoqRun({
                data : {id : boqId,name:name, reference : self.boqRefUpdate, isPrimary : self.boqIsPrimaryUpdate},
                pager : {id : projectId ,page : 1, search : ""}
            })
            .then((res)=>{
                btn.disabled = false
                if(res=="OK"){
                    self.$refs.closeUpdateModal.click()
                    self.updateClicked = false
                }
                else{
                    if(self.isDeluxeLayout && self.IsPublishedReferenceBlockedMessage(res)){
                        return
                    }
                    if(self.isDeluxeLayout && self.IsBoqNameAlreadyUsed(res)){
                        self.ShowBoqNameInUseAlert('Update BoQ')
                    }else{
                        self.$swal(self.$i18n.t('Update BoQ'), res, 'warning')
                    }
                }
            })

        },
        DuplicateBoq(elem){
            const self = this
            const projectId = self.$route.params.id
            const btn = elem
            const data = self.boqDuplicate
            self.duplicateClicked = true
            if(!data.boqName){
                return
            }
            btn.disabled = true
            self.tableIsLoading = true
            self.duplicateClicked = false
            self.DuplicateBoqRun({
                    data : {projectId : projectId, name : data.boqName, reference : data.boqRef, isPrimary : data.boqIsPrimary, duplicatedId : data.duplicatedId},
                    pager : {id : projectId ,page : 1, search : ""}
            })
            .then((res)=>{
                self.tableIsLoading = false
                btn.disabled = false
                if(res!="OK"){
                    self.$swal(self.$i18n.t('Duplicate BoQ'), res, 'warning')
                }else{
                    self.$refs.closeDuplicateModal.click()

                }
            }).catch()
        },
        CombineBoqRun(e){
            const self = this
            let btn = e.target
            const newData = self.boqCombine

            self.combineClicked = true
            if(!newData.boqName || newData.selectedCount==0){
                return
            }

            btn.disabled = true
            self.combineClicked = false
            CombineBoq(newData).then((res)=>{
                btn.disabled = false
                if(res=='OK'){
                    self.$refs.closeCombineModal.click()
                    self.tableIsLoading = true
                    self.GetBoqListRun({id : self.$route.params.id, page : 1, search : ''}).then(()=>{
                        self.tableIsLoading = false
                    }).catch()
                }else{
                    self.$swal('Combine BoQ',res,'warning')
                }
            })
        },
        searchRun(value){
            this.QueueBoqSearch(value)
        },
        QueueBoqSearch(value){
            const self = this
            self.timerSetter(value,function(){
                self.RunBoqSearch(value)
            },true)
        },
        RunBoqSearch(value){
            const self = this
            const projectId = self.$route.params.id
            const searchText = value || ''

            if(self.isDeluxeLayout){
                self.activeSearchBar = searchText
            }

            self.tableIsLoading = true
            self.GetBoqListRun({id : projectId, page : 1, search : searchText}).then(()=>{
                self.tableIsLoading = false
            }).catch(()=>{
                self.tableIsLoading = false
            })
        },
        SearchBoqs(){
            const self = this
            const projectId = self.$route.params.id
            if(self.timer){
                clearTimeout(self.timer)
                self.timer = null
            }

            self.activeSearchBar = self.searchBar || ''
            self.activeStatusFilter = self.statusFilter || ''
            self.tableIsLoading = true
            self.GetBoqListRun({id : projectId, page : 1, search : self.activeSearchBar}).then(()=>{
                self.tableIsLoading = false
            }).catch(()=>{
                self.tableIsLoading = false
            })
        },
        ChangeBoqPage(page){
            const self = this
            const projectId = self.$route.params.id
            const nextPage = Math.min(Math.max(Number(page) || 1, 1), self.paginationDetails.totalPages)
            if(nextPage == self.paginationDetails.page){
                return
            }

            self.tableIsLoading = true
            self.GetBoqListRun({id : projectId, page : nextPage, search : self.appliedSearchBar}).then(()=>{
                self.tableIsLoading = false
            }).catch(()=>{
                self.tableIsLoading = false
            })
        },
        OpenOfficeImport(){
            this.boqOfficeTemplate = {
                templateType: '',
                boqRef: '',
                file: ''
            }
            this.$refs.uploadFileOfficeTemplate.value = ''
            this.uploadPercentage = 0
            this.uploadMessage = ''
        },
        OpenCreate(){
            this.boqName = ''
            this.boqRef =''
            this.boqCurrencyId = ''
        },
        OpenDuplicateModal(id, name, currency, reference, isPrimary){
            this.boqDuplicatedName = name 
            this.boqDuplicate.duplicatedId = id
            this.boqDuplicate.boqName = name 
            // this.boqDuplicate.boqRef = reference
            this.boqDuplicate.boqCurrencyId = currency
            this.boqDuplicate.boqIsPrimary = isPrimary
        },
        OpenCombineModal(){
            this.boqCombine = {
                currencyId : '',
                selected : this.selected,
                selectedCount : this.selected.length,
                id : this.$route.params.id
            }
        },
        UpdateSelectedValue (value){
            this.selected = value
        },
        DeleteBoq(id,name){
            const self = this

            const swalTitle = self.$i18n.t('Delete BoQ')

            self.$swal({
                title: swalTitle,
                text : `"${name}" ${self.$i18n.t('will be Deleted Permanently, Proceed?')}'`,
                showCancelButton: true,
                icon: 'warning',
                showLoaderOnConfirm : true,
                allowOutsideClick: () => !self.$swal.isLoading(),
                preConfirm : ()=>{
                    return DeleteBoq(id).then((res)=>{
                        return res
                    })
                }
            }).then((res)=>{
                if(res.isConfirmed){
                    if(res.value=='OK'){
                        self.DeleteBoqPermanent(id)
                        self.$swal(swalTitle,self.$i18n.t('Deleted Successfully'),'success')
                    }else{
                        self.$swal(swalTitle,res.value,'warning')
                    }
                
                }
            })
        },
        UploadProcess(progressEvent){
            this.uploadPercentage = parseInt( Math.round( ( progressEvent.loaded / progressEvent.total ) * 90 ) );
            if(this.uploadPercentage >=90){
                this.uploadMessage = 'Processing your file'
            }else{
                this.uploadMessage = 'Uploading your file'
            }
        },
        UploadOfficeTemplate(e){
            let data = new FormData()
            const self = this
            this.uploadPercentage = 0
            if(self.isImportRunning){
                return
            }
            const file = self.$refs.uploadFileOfficeTemplate.files[0]
            const newData = self.boqOfficeTemplate
            const btn = e.target
            self.isImportClicked = true
            newData.file = ''
            if(!file ){
                return
            }
            newData.file = 'new file'

            if(newData.templateType===''){
                return
            }

            if(!newData.boqRef){
                return
            }

            data.append('id',self.projectInfo._id)
            data.append('templateType',newData.templateType)
            data.append('reference',newData.boqRef)
            data.append('template',file)

            console.log('[office import request]', {
                projectId: self.projectInfo._id,
                templateType: newData.templateType,
                reference: newData.boqRef,
                file: {
                    name: file.name,
                    size: file.size,
                    type: file.type
                }
            })

            self.isImportClicked = false
            btn.disabled = true

            const swalTitle = self.$i18n.t('Import')

            if(newData.templateType==1 || newData.templateType==2|| newData.templateType==3){
                self.isImportRunning = true
                UploadOfficeTemplateToMasterList(data,this.UploadProcess).then((res)=>{
                    self.isImportRunning = false
                    btn.disabled = false
                    this.uploadPercentage = 100
                    this.uploadMessage = 'File Processed'
                    if(res=='OK'){
                        self.$refs.closeBoqImportOfficeTemplates.click()
                        self.tableIsLoading = true
                        self.GetBoqListRun({id : self.$route.params.id, page : 1, search : ''}).then(()=>{
                            self.tableIsLoading = false
                        }).catch()
                    }
                    else{
                        self.$swal(swalTitle,res,'warning')
                    }
                })
            }else{
                btn.disabled = false
                this.$swal(swalTitle,self.$i18n.t('Sorry not yet implemented'),'warning')
            }
            
        },

    },
    watch : {
        searchBar(value){
            if(this.isDeluxeLayout){
                this.QueueBoqSearch(value)
            }
        }
    },
    beforeUnmount(){
        if(this.timer){
            clearTimeout(this.timer)
        }
    },
    computed : {
        ...mapGetters(['projectInfo', 'boqCurrency','permission','boqList']),
        isDeluxeLayout(){
            return this.$route.meta.layout == 'deluxe'
        },
        currencyLabel(){
            const currency = this.projectInfo.currencyId || {}
            const currencyName = this.FormatCurrencyName(currency.name || currency.code || currency.shortName || currency.sign || '')
            const currencySign = currency.sign || ''

            if(currencyName && currencySign){
                return `${currencyName} (${currencySign})`
            }

            return currencyName || currencySign || '-'
        },
        appliedSearchBar(){
            return this.isDeluxeLayout ? this.activeSearchBar : this.searchBar
        },
        appliedStatusFilter(){
            return this.isDeluxeLayout ? this.activeStatusFilter : this.statusFilter
        },
        quotationReferenceList(){
            return (this.quotationList || []).map((quotation)=>{
                const status = quotation.approvalStage ?? quotation.status
                const isPublished = Number(status) === ApprovalStageBoq.PUBLISHED || String(status || '').toUpperCase() === 'PUBLISHED'

                return {
                    ...quotation,
                    isReferenceDisabled: isPublished,
                    referenceOptionRemark: isPublished ? this.$t('Published - cannot be selected as reference') : ''
                }
            })
        },
        paginationDetails(){
            const totalPages = Math.max(Number(this.boqList.totalPages) || 1, 1)
            const page = Math.min(Math.max(Number(this.boqList.page) || 1, 1), totalPages)

            return {
                totalPages,
                page
            }
        }
    },
    data(){
        return {
            tableIsLoading :true,
            searchBar : '',
            statusFilter : '',
            activeSearchBar : '',
            activeStatusFilter : '',
            boqName : '',
            boqRef : '',
            boqCurrencyId : '',
            boqNameUpdate : '',
            boqRefUpdate : '',
            boqCurrencyIdUpdate : '',
            boqIsPrimaryUpdate : false,
            boqUpdateId : '',
            boqOriginalUpdate : {
                name: '',
                reference: ''
            },
            boqCombine : {
                selected : '',
                id : this.$route.params.id,
                selectedCount : 0
            },
            selected : [],
            saveClicked : false,
            updateClicked : false,
            boqDuplicate : {},
            boqDuplicatedName : '',
            boqOfficeTemplate : {},
            isImportClicked : false,
            duplicateClicked : false,
            combineClicked : false,
            timer : null,
            projectUrl : process.env.VUE_APP_PROJECT_URL,
            dotnetUrl : process.env.VUE_APP_DOTNET_URL,
            quotationList : [],
            ModuleActionList : ModuleActionList,
            ApprovalStageBoqObj : ApprovalStageBoqObj,
            isImportRunning : false,
            uploadPercentage : 0,
            uploadMessage : ''
        }
    }

    
}
